// @ts-nocheck
export const VC_explanation =
  "Risk Adjusted Value (RAV) is the dollar value our protocol interprets your Total Collateral to be worth. You'll be able to withdraw more LUSD if you deposit $1 worth of a safer asset versus depositing $1 worth of a more risky asset as collateral. RAV = Safety Ratio * Price * Collateral Amount";
